// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Name: 'name',
	Jurisdiction: 'jurisdiction',
	CorporationNumber: 'corporation-number',
	DateOfIncorporation: 'date-of-incorporation',
	BusinessActivity: 'business-activity',
	RecordSource: 'record-source',
	BusinessPhone: 'business-phone',
	BusinessFax: 'business-fax',
	BusinessEmail: 'business-email',
	PrimarySalutation: 'primary-salutation',
	EnvelopeSalutation: 'envelope-salutation',
	Input: 'input',
	PrimarySalutationInputWrapper: 'primary-salutation-input-wrapper',
	EnvelopeSalutationInputWrapper: 'envelope-salutation-input-wrapper',
	CanadianCompanyRadioGroup: 'canadian-company-radio-group',
	ProvinceOfIncorporationRegionSelect:
		'province-of-incorporation-region-select',
	DetailsSection: 'details-section',
	ContactDetailsSection: 'contact-details-section',
	SalutationsSection: 'salutations-section',
	TypeSelect: 'type-select',
	PrimarySalutationTypeSelect: 'primary-salutation-type-select',
	EnvelopeSalutationTypeSelect: 'envelope-salutation-type-select',
	TextArea: 'text-area',
	Option: 'option',
	Option1: 'option-1',
	Option2: 'option-2',
	Option3: 'option-3',
	Option4: 'option-4',
	Option5: 'option-5',
	Option6: 'option-6',
	Option7: 'option-7',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
